import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Context } from '../../context/UserContext';
import {  X, Menu, LogOut, User, Zap, Star, Shield } from 'lucide-react';

import styles from "./styles.module.css";
// personal components
import Logo from '../../componentes/Logo';

const PLAN_INFO = {
    free: { name: "Gratuito", icon: Shield },
    plus: { name: "Plus", icon: Zap },
    premium: { name: "Premium", icon: Star },
}

function Navbar(){
    const { authenticated, user, logout } = useContext(Context);
    const [mobildeMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    const plan = user?.plan ?? "free";
    const planInfo = PLAN_INFO[plan] ?? PLAN_INFO.free;
    const PlanIcon = planInfo.icon;

    function closeMenu() { setMobileMenuOpen(false); }

    function handleLogout() {
        closeMenu();
        logout();
    }

    // Links de navegação deslogado - usados em desktop e mobile
    const NAV_LINKS = [
        { label: "Recursos", to: "/#features" },
        { label: "Planos", to: "/planos" },
        { label: "Depoimentos", to: "/#carrossel"}
    ];

    return(
        <header className={styles.header}>
            <div className={styles.headerContent}>
                <Logo />
                {/* Desktop Navigation */}
                <nav className={styles.desktopNav}>
                        {authenticated ? (
                            <>
                                <div className={styles.logedUser}>
                                   {user?.image ? (
                                        <img
                                            src={user.image}
                                            alt="Foto de perfil"
                                            className={styles.userImage}
                                        />
                                    ) : (
                                        <User size={24} color="#fcfcfc" />
                                    )}

                                    <span className={styles.userName}>{user?.name || 'Usuário'}</span>
                                    <span className={`${styles.planBadge} ${styles[plan]}`}>
                                        {planInfo?.name || "Plano"}
                                    </span>
                                </div>
                                <button className={styles.anchor} onClick={logout}><LogOut sieze={16} />Sair</button>
                            </>
                        ) : (
                            <>
                                {NAV_LINKS.map((link) => (
                                    <Link key={link.to} className={styles.anchor} to={link.to}>{link.label}</Link>
                                ))}
                                {/*<a className={styles.anchor} href='#contacts'>Contato</a>*/}
                                <Link className={styles.loginButton} to='/login'>Entrar</Link>
                                <Link className={styles.ctaButton} to='/register'>Começar Grátis</Link>
                            </>
                        )}
                </nav>

                {/* Mobile Button */}
                <button onClick={() => setMobileMenuOpen((prev) => !prev)} className={styles.mobileMenuButton} aria-label={mobildeMenuOpen ? "Fechar menu" : "Abrir menu"}>
                    {mobildeMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>
            {/* Mobile Navigation */}
            {mobildeMenuOpen && (
                <nav className={styles.mobileNav}>
                    {authenticated ? (
                        <>
                            <div className={styles.mobileUser}>
                                {user?.image ? (
                                    <img src={user.image} alt="Foto do perfil" className={styles.mobileUserImage} />
                                ) : (
                                    <div className={styles.mobileUserAvatar}>
                                        <User size={20} color="#a5b4fc" />
                                    </div>
                                )}
                                <div className={styles.mobileUserInfo}>
                                    <span className={styles.mobileUserName}>{user?.name || "Usuário"}</span>
                                    <span classname={`${styles.planBadge}`}><PlanIcon size={11} /> {planInfo.name}</span>
                                </div>
                            </div>
                            <div className={styles.mobileDivider} />

                            <Link className={styles.mobileAnchor} to="/dashboard" onClick={closeMenu}>Dashboard</Link>
                            <Link className={styles.mobileAnchor} to="/planos" onClick={closeMenu}>Meu Planos</Link>

                            <div className={styles.mobileDivider} />
                            <button className={styles.mobileLogoutButton} onClick={handleLogout}><LogOut size={16} />Sair</button>
                        </>
                    ) : (
                        <>
                             {NAV_LINKS.map((link) => (
                                <Link
                                    key={link.to}
                                    className={styles.mobileAnchor}
                                    to={link.to}
                                    onClick={closeMenu}
                                >
                                    {link.label}
                                </Link>
                            ))}
 
                            <div className={styles.mobileDivider} />
 
                            <Link
                                className={styles.mobileLoginButton}
                                to="/login"
                                onClick={closeMenu}
                            >
                                Entrar
                            </Link>
                            <Link
                                className={styles.mobileCTAButton}
                                to="/register"
                                onClick={closeMenu}
                            >
                                Começar Grátis
                            </Link>
                        </>
                    )}
                </nav>
            )}
        </header>
    )
}

export default Navbar;